module.exports = __webpack_public_path__ + "img/00044.ddfcaab4.webp";